import { useTranslation } from "react-i18next";
import leaf from "../../../assets/leaf.svg";

import "./index.scss";

export const SustenabilitySection = () => {
  const { t } = useTranslation("")
  return (
    <div className="c-sustenability-section">
      <div className="c-sustenability-section__decoration"></div>
      <img src={leaf} className="c-sustenability-section__leaf" alt="leaf" />
      <h1 className="c-sustenability-section__title">
      {t("presentationPage.pledge")}
        {/* Sustainability <br /> pledge */}
      </h1>
      <p className="c-sustenability-section__description">
        {t("presentationPage.watugot-aims")}
        {/* <span className="c-sustenability-section__description--highlighted">
          reduce carbon dioxide
        </span>
        (CO<sub>2</sub>) emissions. */}
        <br /> <br />
        {t("presentationPage.watugot-aims-1")}
        {/* Our platform helps reduce unnecessary transportation and packaging{" "}
        <br />
        emissions associated with traditional retail and ecommerce while
        enhancing <br />
        community relations. */}
      </p>
      <button className="c-sustenability-section__button"> {t("presentationPage.how-works")}</button>
    </div>
  );
};
